export default __webpack_public_path__ + "static/butterfly-483bbdc4fcfcd609019a45f64b27befd.gif";